import { LOCK } from 'Data/payment-plan.js'

export function getView(lock) {
  return lock === LOCK.INSTALLMENT_AMOUNT ? 'UnlockIcon' : 'LockIcon'
}
